import { render, staticRenderFns } from "./ClinicPrices.vue?vue&type=template&id=e27b0bca&scoped=true&"
import script from "./ClinicPrices.vue?vue&type=script&lang=js&"
export * from "./ClinicPrices.vue?vue&type=script&lang=js&"
import style0 from "./ClinicPrices.vue?vue&type=style&index=0&id=e27b0bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27b0bca",
  null
  
)

export default component.exports